import styled from 'styled-components';

import { ButtonSquare } from '@xsolla/ui-core';

export const FormWrapper = styled.div`
  > div:nth-child(odd) {
    margin-top: 24px;
  }
`;

export const ExtraButtonStyled = styled(ButtonSquare)`
  margin-left: 8px;
`;

export const MapDivider = styled.div`
  width: 3%;
  margin: 0 10px;
  height: 1px;
  border: none;
  background-color: #c5d0db;
  position: relative;
`;

export const MapWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const MappingInputWrapper = styled.div`
  width: 100%;
`;

export const AddFields = styled.button<{ disabled: boolean }>`
  ${(p) => p.theme.typography.body}
  width: 100%;
  border: 1px solid rgba(0, 115, 247, 0.32);
  background: transparent;
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  color: ${({ disabled, theme }) => (disabled ? theme.colors.muted : theme.colors.brand)};
`;

export const Container = styled.div`
  padding-top: 1rem !important;
  max-width: 850px !important;
`;

export const MergeTagRow = styled.div`
  margin-bottom: 1.5rem !important;
  max-height: 44px !important;
`;

export const RowContent = styled.div`
  display: flex !important;
  gap: 0.4rem !important;
  align-items: center !important;
  height: 42px !important;
`;

export const SelectContainer = styled.div`
  flex: 1 !important;
  max-width: 250px !important;
  display: flex !important;
  align-items: center !important;
`;

export const InputContainer = styled.div`
  flex: 1 !important;
  max-width: 250px !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
`;

export const StyledInput = styled.input<{ hasError?: boolean }>`
  display: block !important;
  border-radius: 4px !important;
  border: 1px solid ${(props) => (props.hasError ? 'red' : '#ccc')} !important;
  width: 100% !important;
  height: 100% !important;
  padding-left: 0.5rem !important;
`;

export const ErrorContent = styled.div`
  display: flex !important;
  gap: 0.4rem !important;
  align-items: center !important;
  height: 35px !important;
`;

export const ErrorContainer = styled.div`
  flex: 1 !important;
  max-width: 250px !important;
  height: 20px !important;
  display: flex !important;
  align-items: center !important;
`;

export const ErrorMessage = styled.div`
  color: red !important;
  font-size: 10px !important;
  line-height: 10px !important;
`;

export const AddFieldsContainer = styled.div`
  display: flex !important;
  gap: 1rem !important;
  margin-top: 1rem !important;
`;
